
import { Navigate, useLocation } from "react-router-dom";
import useAuth from "../auth/useAuth";


const PrivateRoute = ({ hasRole: role, children }) => {
  const location = useLocation(); 
  const {hasRole, isLogged} = useAuth();
  
  if (role && !hasRole(role)) return <Navigate to="/" replace state={{from:location}}/>;

  if(!isLogged()) return <Navigate to="/login" replace state={{from:location}}/>;

  return children;
};

export default PrivateRoute;